import React from "react";
import "../App.css";

export default function About() {
  return (
    <div className="page">
      <h2>About Conscious Neurons</h2>

      <p>
        Founded by visionary technologists, Conscious Neurons is a software lab
        focused on building meaningful AI solutions that amplify human
        capabilities and simplify complex processes.
      </p>

      <p>
        Our philosophy blends deep neural computation with conscious design
        principles. We believe artificial intelligence should feel intuitive,
        reliable, and empowering — never cold or disconnected.
      </p>

      <p>
        We operate at the intersection of data science, automation, and
        cognitive architecture — merging logic and empathy into each product we
        deliver. Whether it's neural network development, AI systems
        integration, or custom software platforms, our work is guided by
        clarity, purpose, and respect for the human experience.
      </p>

      <p>
        At Conscious Neurons, we embrace the idea that AI is not just a tool,
        but a co-evolutionary force — one that can help individuals, teams, and
        societies flourish when built with awareness and care.
      </p>

      <p>
        Conscious Neurons is more than a company — it's a movement toward
        responsible, adaptive, and deeply integrated AI for a conscious world.
      </p>

      <h3>Our Team</h3>
      <p>
        We are a collective of engineers, researchers, and system architects who
        share a passion for advancing human-centered AI. Our team combines
        expertise in machine learning, cognitive science, software architecture,
        and ethical computing. We bring together both analytical precision and
        visionary thinking to shape tools that feel alive with intent.
      </p>

      <p>
        The founding vision was born from a simple yet profound question:
        <em>
          What if technology didn’t just work — what if it felt conscious?
        </em>
        That inquiry continues to guide every system we build, every model we
        train, and every client we serve.
      </p>
    </div>
  );
}
